import * as React from 'react';
import type { SVGProps } from 'react';
const SvgIdentitiesFull = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    viewBox="0 0 30 30"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 8a8 8 0 0 1 8-8h14a8 8 0 0 1 8 8v14a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
    />
    <path
      fill="url(#IdentitiesFull_svg__a)"
      fillOpacity={0.4}
      d="M0 8a8 8 0 0 1 8-8h14a8 8 0 0 1 8 8v14a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
    />
    <g opacity={0.9}>
      <path
        fill="url(#IdentitiesFull_svg__b)"
        fillRule="evenodd"
        d="M20.227 22.091c1.158 0 2.127-.928 1.8-2.004-.893-2.949-3.707-5.102-7.042-5.102s-6.149 2.153-7.042 5.102c-.326 1.076.643 2.004 1.8 2.004z"
        clipRule="evenodd"
      />
      <path
        fill="url(#IdentitiesFull_svg__c)"
        d="M18.13 10.924c0 1.682-1.408 3.045-3.145 3.045s-3.145-1.363-3.145-3.045 1.408-3.046 3.145-3.046 3.145 1.364 3.145 3.046"
      />
    </g>
    <defs>
      <linearGradient
        id="IdentitiesFull_svg__a"
        x1={24.374}
        x2={-13.126}
        y1={22.031}
        y2={21.25}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EA798F" />
        <stop offset={1} stopColor="#FCECEF" />
      </linearGradient>
      <linearGradient
        id="IdentitiesFull_svg__b"
        x1={19.427}
        x2={1.661}
        y1={18.316}
        y2={17.946}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EA798F" />
        <stop offset={1} stopColor="#F2ACB9" />
      </linearGradient>
      <linearGradient
        id="IdentitiesFull_svg__c"
        x1={19.427}
        x2={1.661}
        y1={18.316}
        y2={17.946}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EA798F" />
        <stop offset={1} stopColor="#F2ACB9" />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgIdentitiesFull;
